import React, { useEffect } from "react";
import Container from "@mui/material/Container";
import Contact from "../Contact/contact";
import Badface from "@mui/icons-material/SentimentVeryDissatisfied";
//import ReactGA from "react-ga4";

const Notfound = () => {
  useEffect(() => {
    //ReactGA.send("/notfound");
  }, []);

  return (
    <>
      <Container
        maxWidth="sm xs lg"
        sx={{ backgroundColor: "white" }}
        disableGutters
      >
        <div className="main-bg14"></div>
      </Container>
      <Container maxWidth="sm xs lg" sx={{ p: 2, backgroundColor: "white" }}>
        <section>
          <h3 style={{ textAlign: "center" }}>
            LO SENTIMOS
            <br />
            <br />
            <Badface
              sx={{ fontSize: 60, color: "#333", verticalAlign: "middle" }}
            />
          </h3>
          <p>
            <b>Error 404:</b> No hemos encontrado la página solicitada.
          </p>
        </section>
        <br />
        <br />
        <br />
        <br />
      </Container>
      <Contact />
    </>
  );
};

export default Notfound;
